export const widgetConfig = {
  height: 190,
  padding: { top: 10, left: 30, bottom: 20, right: 10 },
  data: [{
    name: 'table',
    values: [{
      x: 'A',
      y: 84,
      avg: 50
    }, {
      x: 'B',
      y: 32,
      avg: 50
    }, {
      x: 'C',
      y: 61,
      avg: 50
    }]
  }],
  axes: [{
    properties: {
      axis: {
        stroke: {
          value: '#979797'
        },
        strokeWidth: {
          value: 1.8
        }
      }
    },
    tickSize: 0,
    values: [],
    type: 'x',
    scale: 'x'
  }, {
    properties: {
      axis: {
        stroke: {
          value: 'transparent'
        }
      },
      ticks: {
        stroke: {
          value: 'transparent'
        }
      },
      labels: {
        fill: {
          value: '#e5eaed'
        },
        fontWeigth: {
          value: 100
        }
      },
      grid: {
        stroke: {
          value: '#e5eaed'
        },
        strokeWidth: {
          value: 0.5
        },
        strokeOpacity: {
          value: 1
        },
        strokeDash: {
          value: [0, 1.5, 1.5]
        }
      }
    },
    type: 'y',
    values: [0, 100],
    ticks: 6,
    layer: 'back',
    nice: true,
    grid: true,
    scale: 'y'
  }],
  marks: [{
    properties: {
      enter: {
        x: {
          field: 'x',
          scale: 'x1',
          offset: 20
        },
        y2: { scale: 'y', value: 0 },
        width: {
          value: 16
        },
        fill: {
          field: '_id',
          scale: 'group'
        },
        y: {
          field: 'y',
          scale: 'y'
        }
      }
    },
    from: {
      data: 'table'
    },
    type: 'rect'
  }, {
    properties: {
      enter: {
        x: {
          field: 'x',
          scale: 'x1',
          offset: 28
        },
        size: {
          value: 68
        },
        fill: {
          value: '#fff'
        },
        y: {
          field: 'avg',
          scale: 'y'
        }
      }
    },
    from: {
      data: 'table'
    },
    type: 'symbol'
  }],
  scales: [{
    name: 'x',
    range: 'width',
    domain: {
      field: 'x',
      data: 'table'
    },
    type: 'ordinal'
  }, {
    name: 'x1',
    range: [15, 140],
    domain: {
      field: 'x',
      data: 'table'
    },
    type: 'ordinal'
  }, {
    name: 'y',
    range: 'height',
    domain: [0, 100],
    type: 'linear'
  }, {
    name: 'group',
    range: [
      '#53caec',
      '#dd5069',
      '#008037'
    ],
    type: 'ordinal'
  }],
  width: 190
};



// WEBPACK FOOTER //
// ./app/constants/Compare/widgetConfig.js